module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.closeBlock) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _c('p', {
    staticClass: "message",
    class: _vm.classes
  }, [_vm._t("default")], 2)]) : _c('p', {
    staticClass: "message",
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bca0cc74","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/resultform/components/message/Message.vue
// module id = 00db9bf8069c8087b06c
// module chunks = 89